import React, { ReactElement, useEffect, useState } from 'react';
import { Collapse, message, Table } from 'antd';
import { isEmpty } from 'lodash';

import ExportCsvData from 'leash/components/exportCsvData/ExportCsvData';
import { PackagesHistoryStyled } from 'leash/components/packagesHistory/PackagesHistory.styles';
import { mapTravelPackagesHistory } from 'leash/utilities/packages/packages.utilities';
import { TravelPackagesHistoryTableData } from 'leash/types';
import { apiPackage } from 'utilities/http/api/leash/apiPackage';

interface Props {
  travelPackageId: number;
}

function PackagesHistory(props: Props): ReactElement {
  const { travelPackageId } = props;
  const [travelPackagesHistory, setTravelPackagesHistory] = useState<
    TravelPackagesHistoryTableData[]
  >([]);
  const [loading, setLoading] = useState(true);

  const handleFetchPackagesHistory = async () => {
    try {
      const resp = await apiPackage.getHistoryPackages(travelPackageId);

      if (resp.isOk) {
        return mapTravelPackagesHistory(resp.json.history);
      }

      message.error('Error fetching travel packages history');
      return [];
    } catch (e) {
      message.error(e.message);
      return [];
    }
  };

  const renderExpandIcon = (isActive: boolean | undefined) => {
    return <span className="expand-icon">{isActive ? 'Collapse' : 'Expand'}</span>;
  };

  useEffect(() => {
    handleFetchPackagesHistory().then((history) => {
      setTravelPackagesHistory(history);
      setLoading(false);
    });
  }, []);

  return (
    <PackagesHistoryStyled
      expandIcon={({ isActive }) => renderExpandIcon(isActive)}
      expandIconPosition="right"
    >
      <Collapse.Panel key="packageHistory" header="Travel history">
        <Table<TravelPackagesHistoryTableData>
          loading={loading}
          dataSource={travelPackagesHistory}
          columns={[
            {
              title: 'Date & time',
              dataIndex: 'dateTime',
              sorter: (a, b) => a.dateTime.localeCompare(b.dateTime),
              width: '15%',
            },
            {
              title: 'Type',
              dataIndex: 'actionType',
              sorter: (a, b) => a.actionType.localeCompare(b.actionType),
              width: '10%',
            },
            {
              title: 'User',
              dataIndex: 'user',
              sorter: (a, b) => a.user.localeCompare(b.user),
              width: '15%',
            },
            {
              title: 'Field',
              dataIndex: 'field',
              sorter: (a, b) => a.field.localeCompare(b.field),
              width: '16%',
            },
            {
              title: 'Old',
              dataIndex: 'oldValue',
              sorter: (a, b) => `${a.oldValue}`.localeCompare(`${b.oldValue}`),
              width: '22%',
            },
            {
              title: 'New',
              dataIndex: 'newValue',
              sorter: (a, b) => `${a.newValue}`.localeCompare(`${b.newValue}`),
              width: '22%',
            },
          ]}
          footer={() =>
            !isEmpty(travelPackagesHistory) && (
              <span className="table-footer-tools">
                <ExportCsvData
                  data={travelPackagesHistory}
                  dataType="travelPackagesHistory"
                />
              </span>
            )
          }
          pagination={{
            defaultPageSize: 25,
            position: ['bottomCenter'],
          }}
        />
      </Collapse.Panel>
    </PackagesHistoryStyled>
  );
}

export default PackagesHistory;
